import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';

// Import page components
import Home from './pages/Home';
import Steps from './pages/Steps';
import ReduceSpending from './pages/ReduceSpending';
import LowerDebt from './pages/LowerDebt';
import PrepareEmergencies from './pages/PrepareEmergencies';
import StartInvesting from './pages/StartInvesting';
import AvoidIndividualStocks from './pages/AvoidIndividualStocks';
import BuyIndexFunds from './pages/BuyIndexFunds';
import MakeAutomaticInvestments from './pages/MakeAutomaticInvestments';
import BePatient from './pages/BePatient';
import PlanRetirement from './pages/PlanRetirement';
import SaveCollege from './pages/SaveCollege';
import GiveBack from './pages/GiveBack';
import ClosingThoughts from './pages/ClosingThoughts';

// Import layout components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <div className="container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/steps-to-financial-freedom" element={<Steps />} />
            <Route path="/reduce-your-spending" element={<ReduceSpending />} />
            <Route path="/lower-your-debt" element={<LowerDebt />} />
            <Route path="/prepare-for-emergencies" element={<PrepareEmergencies />} />
            <Route path="/start-investing" element={<StartInvesting />} />
            <Route path="/avoid-picking-individual-stocks" element={<AvoidIndividualStocks />} />
            <Route path="/buy-low-cost-index-funds" element={<BuyIndexFunds />} />
            <Route path="/make-automatic-investments" element={<MakeAutomaticInvestments />} />
            <Route path="/be-patient" element={<BePatient />} />
            <Route path="/plan-for-retirement" element={<PlanRetirement />} />
            <Route path="/save-for-college" element={<SaveCollege />} />
            <Route path="/give-back" element={<GiveBack />} />
            <Route path="/closing-thoughts" element={<ClosingThoughts />} />
          </Routes>
        </div>
        <Analytics />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
